
import { common, commonApi } from "@/common/index";
import { mapState, mapActions } from "vuex";
import Qrcode from 'vux/src/components/qrcode/index.vue'

import publicMX from "../../mixins/publicMX.js";
import { parseTime } from "@/common/utils/Date.js";
export default {
components: { Qrcode },
mixins: [publicMX],
filters: {
timeFilter(time) {
return parseTime(time);
},
},
data() {
return {
query: {
regH5Link: "http://m.dev.616e.com/register",
inviteCode: "",
},
pages: {
pageNo: 1,
pageSize: 9999,
},
UUID: "",
list: [],
};
},
created() {
this.UUID =
this.$store.state.UUID === ""
? this.$Cookies.get("UUID")
: this.$store.state.UUID;
this.getIniteCode();
this.getInviteList();
},
computed: {
...mapState({
linkList: (state) => state.linkList,
isLogin: (state) => state.isLogin,
}),
},
methods: {
getIniteCode() {
if (this.UUID === "") return;
commonApi.VIP.inviteCode().then((data) => {
this.query = { ...this.query, ...data };
});
},

getInviteList() {

if (this.UUID === "") return;
commonApi.VIP.inviteList({ ...this.pages, UUID: this.UUID })
.then((data) => {
this.list = data;
})
.catch((err) => {
if (this.pages.pageNo === 1) this.list = [];
});
},

getInviteBonus(id) {

if (this.UUID === "") {
this.$vux.toast.show({
text: this.$t("discounts.needLoin"),
type: "cancel",
});
return;
}
window.open("/chatlink.html", "_blank");









},
},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/InviteFriends/index.vue